export default __webpack_public_path__ + "static/media/vivien.973641e9.png";